import routeReplaceSelf from '@/utils/routeReplaceSelf';

const custTaskManage = {
    path: 'custTaskManage',
    name: 'custTaskManage',
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'task',
        icon: 'HSIconfont hs-icon-task',
        showRealm: ['SYSTEM']
    },
    children: [
        {
            path: 'custTaskCycle',
            name: 'custTaskCycle',
            component: routeReplaceSelf(() => import('@/views/custTaskCycle')),
            meta: { code: 'task:timerGroup' },
            children: [
                {
                    path: 'custTaskCycleDetial',
                    name: 'custTaskCycleDetial',
                    hidden: true,
                    component: () => import('@/views/custTaskCycleDetial'),
                    meta: {
                        code: 'task:timerGroupDetial',
                        activeMenu: 'custTaskCycle',
                    },
                }
            ]
        },
        {
            path: 'custTaskRepush',
            name: 'custTaskRepush',
            component: () => import('@/views/custTaskRepush'),
            meta: { code: 'task:repushTask' }
        },
        {
            path: 'custTaskClean',
            name: 'custTaskClean',
            component: routeReplaceSelf(() => import('@/views/custTaskClean')),
            meta: { code: 'task:dataClean' },
            children: [
                {
                    path: 'custTaskCleanDetail',
                    name: 'custTaskCleanDetail',
                    hidden: true,
                    component: () => import('@/views/custTaskCleanDetail'),
                    meta: {
                        code: 'task_dataClean_timerTaskHistory',
                        activeMenu: 'custTaskClean',
                    },
                },
            ]
        },
    ]
};
export default custTaskManage;